import script from "./CreateCustomerModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCustomerModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateCustomerModal.vue?vue&type=style&index=0&id=5d24f975&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d24f975"]])

export default __exports__